import SubscriptionPlanIcon from "features/subscriptions/components/SubscriptionPlanIcon";

import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

import { PLAN_SETTINGS_BACKGROUNDS } from "../../constants";
import {
  PlanSettingsCard,
  PlanSettingsDetailsPanel,
  PlanSettingsLeftPanel,
} from "../PlanSettingsCard";

const PLAN_FEATURES = [
  "Outreach plan included",
  "Delivery in 1-2 business days",
  "Profile Customization",
  "Replacement guarantee",
];

interface AvatarPlanCardProps {
  onGetMoreAvatars: () => void;
}

export default function AvatarPlanCard({
  onGetMoreAvatars,
}: AvatarPlanCardProps) {
  const { rental_subscriptions, total_rented_count } =
    useSelectedWorkspaceContext();

  let rentalSubscriptionsCount = 0;

  if (rental_subscriptions) {
    rentalSubscriptionsCount = rental_subscriptions.filter(
      ({ status }) => status !== "cancelled",
    ).length;
  }

  return (
    <PlanSettingsCard
      backgroundClassName={PLAN_SETTINGS_BACKGROUNDS.avatar}
      left={
        <PlanSettingsLeftPanel
          icon={<SubscriptionPlanIcon plan="rental" size="sm" />}
          title="Avatar plan"
          features={PLAN_FEATURES}
          action={
            <Button className="ml-auto" size="sm" onClick={onGetMoreAvatars}>
              Get more avatars
            </Button>
          }
        />
      }
      right={
        <PlanSettingsDetailsPanel className="p-6 gap-7">
          <span className="text-xs-medium">Avatars</span>

          <div className="flex flex-col gap-4">
            <div className="flex flex-row justify-between items-center gap-4">
              <span className="text-xs-medium text-black-500">
                Total number of avatars
              </span>

              <Tag variant="tertiary" size="md">
                {total_rented_count}
              </Tag>
            </div>

            <div className="flex flex-row justify-between items-center gap-4">
              <span className="text-xs-medium text-black-500">
                Number of orders
              </span>

              <Tag variant="tertiary" size="md">
                {rentalSubscriptionsCount}
              </Tag>
            </div>
          </div>
        </PlanSettingsDetailsPanel>
      }
    />
  );
}
